export default {
  initUserStaffFilter: false,
  resultsPerPage: 50
};
